import { Grid, GridItem, useTheme } from '@chakra-ui/react';

import { Button, Text } from 'ui';

interface AddCardBoxProps {
  label: string;
  isDisabled?: boolean;
  borderRadius?: string;
  onSelectCard: () => void;
}

const AddCardBox = ({
  label,
  isDisabled = false,
  borderRadius = '6px',
  onSelectCard
}: AddCardBoxProps) => {
  const {
    colors: {
      palette: {
        components: { paymentList }
      }
    }
  } = useTheme();

  return (
    <Grid
      px={{ base: '16px', md: '30px' }}
      py={{ base: '12px', md: '16px' }}
      templateColumns='repeat(12, 1fr)'
      columnGap='10px'
      backgroundColor={paymentList.cardBg}
      borderTopRadius={borderRadius}
      borderBottomRadius='6px'
      alignItems='center'
      h='92px'
    >
      <GridItem colSpan={1}>
        <Button
          colorScheme='primaryLight'
          variant='outline'
          onClick={onSelectCard}
          lineHeight='18px'
          fontSize='13px'
          h='35px'
          w='106px'
          bgColor={paymentList.buttonBg}
          py='9px'
          px='31px'
          _active={{
            background: paymentList.buttonActiveBg,
            borderColor: paymentList.buttonActiveBorderColor,
            color: paymentList.buttonActiveColor
          }}
          isDisabled={isDisabled}
        >
          Select
        </Button>
      </GridItem>
      <GridItem colSpan={11}>
        <Text
          ml={{ base: 0, sm: '8px', md: '41px' }}
          fontSize={{ base: '15px', sm: '16px', md: '26px', lg: '28px' }}
          lineHeight={{ base: '20px', sm: '22px', md: '30px', lg: '32px' }}
          textAlign={{ base: 'right', md: 'left' }}
        >
          {label}
        </Text>
      </GridItem>
    </Grid>
  );
};
export default AddCardBox;
